import { Outlet, NavLink, Link } from "react-router-dom";

import rf_logo from "../../assets/logo_color_neg_optimized.png.jpg";

import styles from "./Layout.module.css";

import { useLogin } from "../../authConfig";

import { LoginButton } from "../../components/LoginButton";

const Layout = () => {
    return (
        <div className={styles.layout}>
            <Outlet />
        </div>
    );
};

export default Layout;
